
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/wypozyczalnie",
      function () {
        return require("private-next-pages/[region]/[resort]/wypozyczalnie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/wypozyczalnie"])
      });
    }
  